module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_6.c7467064.png";